// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","postContent":"TBFk-fTQSeEBaEsHrsvsx","postText":"_2FVwOQdWmCeQjz8enesKAb","feedItemHeader":"_3b6bV3h-OIGKwDPvZAtHfB"};